/**
 * Cleans party name and address by removing leading/trailing quotes, 
 * inner double quotes, and trimming whitespace.
 */
export const cleanPartyOrAddress = (str) => {
  if (str === null || str === undefined) return "";
  let s = String(str).trim();
  // Strip starting and ending quotes (", '), backticks, backslashes, or whitespace
  s = s.replace(/^["'`\s\\]+|["'`\s\\]+$/g, "");
  return s.trim();
};
